var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/connection/Partner/PartnerConnection/InboundApi/index.tsx";
import React from 'react';
import { Stack, Text } from '@adc/parallax-component-library';
import { formatTimestamp } from 'Utilities/dateHelpers';
import i18n from 'Utilities/i18n';
const InboundApi = ({
  partnerConnection
}) => {
  const {
    time,
    monthDate
  } = formatTimestamp(partnerConnection.consent.created, i18n.language, 'MMM d, yyyy');
  return /*#__PURE__*/React.createElement(Stack, {
    margin: "$4",
    padding: "$4",
    backgroundColor: "$surface.container",
    border: "$1.5",
    shadow: "$1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "PartnerConnection.title",
    color: "$text.100",
    fontWeight: "$h4.strong",
    fontSize: "$h4.strong",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 7
    }
  }, i18n.t('ConnectedInboundPartner.subtitle')), /*#__PURE__*/React.createElement(Text, {
    testID: "PartnerConnection.bodyText",
    marginTop: "$2",
    color: "$text.100",
    fontWeight: "$bodyBase.default",
    fontSize: "$bodyBase.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 7
    }
  }, i18n.t('ConnectedInboundPartner.content.connectedInboundPartnerTile.primaryText', {
    partnerName: partnerConnection.partner.name
  })), /*#__PURE__*/React.createElement(Text, {
    testID: "PartnerConnection.connectedAt",
    marginTop: "$4",
    color: "$text.60",
    fontWeight: "$bodySmall.default",
    fontSize: "$bodySmall.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 7
    }
  }, i18n.t('ConnectedRedoxPartner.content.connectedRedoxPartnerTile.bodyText', {
    time,
    monthDate
  })), /*#__PURE__*/React.createElement(Text, {
    testID: "PartnerConnection.connectedAt",
    marginTop: "$4",
    color: "$text.60",
    fontWeight: "$bodySmall.default",
    fontSize: "$bodySmall.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 7
    }
  }, i18n.t('ConnectedInboundPartner.content.connectedInboundPartnerTile.bodyText', {
    partnerName: partnerConnection.partner.name
  })));
};
export default InboundApi;